import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, map, filter, take } from 'rxjs';
import { GeneralInformation } from '../models/system-configuration-model';
import { select, Store } from '@ngrx/store';
import { ApplicationState } from '../../store/application-store';
import * as systemConfigurationActions from '../actions/system-configuration.actions';
import { SystemConfigurationHttpService } from './system-configuration-http.service';
import { State } from '../reducers/system-configuration.reducer';
import { getDefaultApplicationDisplayName } from '@product/services/default-product-name';

@Injectable()
export class SystemConfigurationService {

  constructor(
    private store: Store<ApplicationState>,
    private readonly systemConfigurationHttpService: SystemConfigurationHttpService) { }

  getGeneralInformation(product: string): Observable<GeneralInformation> {
    return this.store.pipe(select((state) => state.systemConfiguration),
      tap((state: State) => {
        if (!state.generalInformationMap.has(product) && !state.loading) {
          this.loadGeneralInformation(product);
        }
      }),
      filter((state: State) => {
        return state.generalInformationMap.has(product);
      }),
      map((state: State) => {
        const result = { ...state.generalInformationMap.get(product) };
        result.applicationName = result.applicationName || getDefaultApplicationDisplayName(product);
        return result;
      }));
  }

  loadGeneralInformation(product: string): void {
    this.store.dispatch(new systemConfigurationActions.Load(product));
    this.systemConfigurationHttpService.getSystemConfiguration(product).pipe(
      take(1),
      tap((generalInfo: GeneralInformation) => {
        this.store.dispatch(new systemConfigurationActions.LoadComplete(product, generalInfo));
      })
    ).subscribe();
  }

}
